import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { AdditionalInsurers } from '../../../shared/models/contract/additional-insurer.model';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { CommonService } from '../../../shared/service/common.service';
import { ValidationUiService } from '../../../shared/service/ui/validation-ui';
import { AdditionalInsurersValidationService } from '../../service/additional-insurer-validation.service';

@Component({
  selector: 'app-additional-insured-dob',
  templateUrl: './additional-insured-dob.component.html'
})
export class AdditionalInsuredDobComponent implements OnInit {
  @Output() public submitAnswer = new EventEmitter<AdditionalInsurers>();
  @Input() contractType: ContractType;

  insurers: AdditionalInsurers[] = [];
  counter = 2;

  constructor(
    private additionalInsurersValidationService: AdditionalInsurersValidationService,
    private commonService: CommonService,
    public validationUiService: ValidationUiService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    if (this.insurers.length === 0) {
      this.insurers = this.contractType.policyHolder.personType
        .filter((x) => x.number > 1)
        .map((s) => {
          const date = this.commonService.customDateFormat(s.birthDate, 'dd/MM/yyyy') || '';
          const birthAgeInYears = s.birthDate && !isNaN(new Date(s.birthDate).getTime())
            ? this.commonService.isValidDateRange(s.birthDate)
            : 0;

          return {
            date,
            birthAgeInYears,
            number: s.number
          };
        }) as AdditionalInsurers[];
    }

    this.additionalInsurersValidationService.addInsurers$.subscribe({
      next: (insurer) => {
        if (this.insurers.length < 8) {
          insurer.number = this.counter;
          this.insurers.push(insurer);
          this.counter++;
        }
      }
    });

    this.additionalInsurersValidationService.removeInsurers$.subscribe({
      next: () => {
        if (this.insurers.length > 0) {
          this.insurers.pop();
          this.counter--;
        }
      }
    });

    this.additionalInsurersValidationService.insurersValid$.subscribe({
      next: (error) => {
        const element = this.document.getElementById('errorContainer') as HTMLElement;
        if (error && error.isInValid) {
          if (this.validationUiService.isInsuredSubmit) {
            this.insurers[error.index].invalid = error.isInValid;
            this.document.getElementById('txtDate' + (error.index + 2))?.classList?.add('error');
            if(element) {
              element.innerHTML = error.errorMessage;
              element?.classList?.remove('hidden');
            }
          }
        } else {
          this.insurers[error.index].invalid = error.isInValid;
          this.document.getElementById('txtDate' + (error.index + 2))?.classList?.remove('error');
          if(element) {
            if (this.insurers.filter((a) => a.invalid === true).length > 0) {
              (this.document.getElementById('errorContainer') as HTMLInputElement).innerHTML = error.errorMessage;
            } else {
              (this.document.getElementById('errorContainer') as HTMLInputElement).innerHTML = error.errorMessage;
            }
          }
        }
      }
    });
  }

  onDateChange(newDate: string, insurer: AdditionalInsurers, index: number): void {
    insurer.date = newDate;
    this.onSubmitAnswer(insurer, index);
  }

  onSubmitAnswer(insurer: AdditionalInsurers, index: number): void {
    insurer.index = index;
    this.submitAnswer.emit(insurer);
    this.additionalInsurersValidationService.isInValid(this.contractType);
  }
}
